import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useForm } from "react-hook-form";
import Paper from "@mui/material/Paper";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import "../components/Table/Table.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import { allChecklist, checklist_inactive } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Tooltip, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Modal, Button, Typography } from "@mui/material";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";
import PreviewIcon from "@mui/icons-material/Preview";
import Box from "@mui/material/Box";
import CircleIcon from "@mui/icons-material/Circle";

const TeacherPrevTransferDetails = ({ role, userData }) => {
  const [error, setErrors] = useState({});

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const rowData = location.state;

  useEffect(() => {
    setIsLoading(true);
    let data = {
      gm_id: userData.data.gm_id,
    };
    allChecklist(data)
      .then((res) => {
        if (res.status === "success") {
          setFilteredData(res.data.checklist);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      });
    setIsLoading(false);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  let navigate = useNavigate();
  const view = (row) => {
    navigate(`/add-checklist`, { state: row });
  };

  const view1 = (rowId) => {
    navigate(`/all-question/${rowId}`);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleImageClick = (imageData) => {
    var w = window.open("about:blank");
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement("iframe")).src =
        "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = "100%";
      w.document.getElementsByTagName("iframe")[0].style.height = "100%";
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };

  const toggleStatus = (rowId, currentStatus) => {
    setIsLoading(true);
    let data = {
      checklist_id: rowId,
    };
    checklist_inactive(data)
      .then((res) => {
        if (res.status === "success") {
          toast.success(res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      });
    setIsLoading(false);
  };
  const handleActionButton = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Past Positions & Transfers")}</h5>
          {/* <div style={{ display: role == 7 ? "none" : "block" }}>
              <button className="btn btn-primary btn-sm" onClick={() => view()}>
                <AddIcon />
                {t("Add Checklist")}
              </button>
  
            </div> */}
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Position Name")}</TableCell>
                  <TableCell align="center">{t("Transfer Date")}</TableCell>
                  <TableCell align="center">{t("Details/Remarks")}</TableCell>
                  <TableCell align="center">{t("Action")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.additionalData.name}
                        </TableCell>
                        <TableCell align="center">
                          {row.additionalData.total_questions}
                        </TableCell>
                        <TableCell align="center">
                          {row.additionalData.posted_at}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            onClick={() => handleActionButton()}
                          >
                            <PreviewIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <h4>
                        <i>No data available</i>
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        <Modal
          open={modalOpen}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60vw",
            margin: "3rem",
            left: "18rem",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "fitContent",
              bgcolor: "background.paper",
              borderRadius:"5px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography id="modal-modal-title">
              <h3>Past Position & Transfers- Details</h3>
            </Typography>
            <Box className="d-flex column mb-2">
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <h4 style={{ fontSize: "23px" }}>Position:</h4>
              </Typography>
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="mx-4"
              >
                <h4 style={{ fontSize: "23px" }}>Sr. Teacher</h4>
              </Typography>
            </Box>
            <Box className="d-flex">
              <ul>
                <li className="my-1">Institution:</li>
                <li className="my-1">Start Date:</li>
                <li className="my-1">End Date:</li>
                <li className="my-1">Responsibilities:</li>
              </ul>
              <ul>
                <li className="my-1">Green Valley High School</li>
                <li className="my-1">August 15, 2021</li>
                <li className="my-1">June 30, 2024</li>
                <li>
                  <ul>
                    <li className="my-1">
                      <CircleIcon
                        style={{ fontSize: "10px", marginLeft: "-2rem" }}
                      />
                      Taught 9th and 10th grade English Language Arts.
                    </li>
                    <li className="my-1">
                      <CircleIcon
                        style={{ fontSize: "10px", marginLeft: "-2rem" }}
                      />
                      Developed and implemented comprehensive lesson plans
                    </li>
                  </ul>
                </li>
              </ul>
            </Box>
            <Box>
              <ul className="d-flex column">
                <li className="my-1">Reason for Transfer:</li>
                <li className="my-1" style={{marginLeft:"3.5rem"}}>
                  Transfer to a new school to explore diverse educational
                  environments and methodologies. This move will allow me to
                  bring fresh perspectives and innovative teaching strategies
                </li>
              </ul>
            </Box>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
            ></Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button color="secondary" onClick={closeModal}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default TeacherPrevTransferDetails;
